import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Container,
  Typography,
  Box,
  Alert,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

import '../../App.css';

const apiUrl = process.env.REACT_APP_API_URL;

const UserPermissions = () => {
  const [permissions, setPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [pages, setPages] = useState([]);
  const [error, setError] = useState('');


  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        console.log('Fetching permissions...');
        const response = await axios.get(`${apiUrl}/permissions`);
        console.log('Fetched data:', response.data);


        
        setPermissions(response.data);

        // استخراج جميع الأدوار بدون تكرار
        const uniqueRoles = [
          ...new Map(
            response.data.map((item) => [item.role_id, item.role_name])
          ).values(),
        ];
        setRoles(uniqueRoles);

        // استخراج جميع الصفحات بدون تكرار
        const uniquePages = [
          ...new Map(
            response.data.map((item) => [item.page_name, item.page_name])
          ).values(),
        ];
        setPages(uniquePages);
      } catch (error) {
        console.error('Error fetching permissions:', error);
        setError('فشل في جلب البيانات.');
      }
    };

    fetchPermissions();
  }, []);

  // تحديث الصلاحيات عند تغيير الـ checkbox
  const handleCheckboxChange = (roleId, pageName) => {
    setPermissions((prevPermissions) => {
      const existingPermission = prevPermissions.find(
        (perm) => perm.role_id === roleId && perm.page_name === pageName
      );

      if (existingPermission) {
        return prevPermissions.map((perm) =>
          perm.role_id === roleId && perm.page_name === pageName
            ? { ...perm, can_access: perm.can_access ? 0 : 1 }
            : perm
        );
      } else {
        return [
          ...prevPermissions,
          {
            permission_id: null,
            role_id: roleId,
            page_name: pageName,
            can_access: 1,
          }, // 🟢 ضمان وجود `role_id` و `page_name`
        ];
      }
    });


  };

  

  return (
    <Container component="main" maxWidth="lg">
      <Box
        className="full-page-element"
        sx={{
          mt: 2.5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {error && <Alert severity="error">{error}</Alert>}
        <Typography variant="h4" sx={{ mb: 2.5 }}>
          عرض الصلاحيات
        </Typography>

        <TableContainer
          component={Paper}
          sx={{ width: '100%', overflowX: 'auto' }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}
                >
                  الصفحة / المجموعة
                </TableCell>
                {roles.map((role) => (
                  <TableCell
                    key={role}
                    sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}
                  >
                    {role}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {pages.map((page) => (
                <TableRow key={page}>
                  <TableCell sx={{ fontWeight: 'bold' }}>{page}</TableCell>
                  {roles.map((role) => {
                    const permission = permissions.find(
                      (p) => p.role_name === role && p.page_name === page
                    );
                    return (
                      <TableCell key={`${role}-${page}`} align="center">
                        <Checkbox
                          checked={permission?.can_access ? true : false}
                          disabled={false}
                          onChange={() =>
                            handleCheckboxChange(
                              permission?.role_id || roles.indexOf(role) + 1,
                              page
                            )
                          }
                        />
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

      </Box>
    </Container>
  );
};

export default UserPermissions;
// not use this page
